let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NJ21")).then(() => parcelRequire('5WJgP'));